import { ObjectSchema } from 'yup';
import { t } from 'i18next';
import Yup from '../../../services/common/validation';
import { BankDetailsFormModel_MX } from './formModel';
import { createAsyncValidator } from '../../../services/common/asyncValidator';
import { useValidateIbanMutation } from '../../../services/redux/features/api/ibanValidator.api-slice';

type ValidateIbanFn = ReturnType<typeof useValidateIbanMutation>[0];

export const getValidationSchema = (validateIban: ValidateIbanFn): ObjectSchema<BankDetailsFormModel_MX> => {
  const ibanValidator = createAsyncValidator(validateIban, { throttleMs: 500 });

  return Yup.object({
    iban: Yup.string()
      .requiredWithMsg()
      .min(10, t('validation:minLength', { value: 10 }))
      .max(40, t('validation:maxLength', { value: 40 }))
      .test('validate-iban', t('validation:invalidIBAN'), async (value) => {
        if (!value || value.length < 10 || value.length > 40) {
          return true;
        }

        try {
          const { data } = await ibanValidator({ iban: value });
          return data?.isValid ?? false;
        } catch (error) {
          return false;
        }
      }),
    bankAccountHolder: Yup.string().requiredWithMsg(),
    preferredPaymentDay: Yup.string().requiredWithMsg(),
  });
};
